import axios from './rest-axios';

const getList = (tableName, params) => axios.get(`/manage/data/${tableName}`, params);
const getSingle = (tableName, where) => axios.get(`/manage/data/${tableName}/single`, where);
const postData = (tableName, data) => axios.post(`/manage/data/${tableName}`, data);
const putData = (tableName, data) => axios.put(`/manage/data/${tableName}`, data);

export {
    getList,
    getSingle,
    postData,
    putData
};
